
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./LPCompSuctDrumA.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function LPCompSuctDrumA() {

        useEffect(() => {
  
    trackPageVisit("LPCompSuctDrumA");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorA, compressorB } = useContext(CompressorContext);

const compressor = compressorA; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    
      const historianData = useMemo(() => {
  return {
    time: compressor.history?.time || [],
    PT_suction: compressor.history?.PT_suction || [],
    PT_discharge: compressor.history?.PT_discharge || [],
    TT_suction: compressor.history?.TT_suction || [],
    TT_discharge: compressor.history?.TT_discharge || [],
    FIC_suction: compressor.history?.FIC_suction || [],
    FIC_discharge: compressor.history?.FIC_discharge || [],
    speed: compressor.history?.speed || []
  };
}, [compressor.history]);




  const DEFAULT_VALVES = {
  FCV_17001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_17001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_17002A: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("LPCompSuctDrumA_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_17001A: { ...DEFAULT_VALVES.FCV_17001A, ...parsed.FCV_17001A },
      PCV_17001A: { ...DEFAULT_VALVES.PCV_17001A, ...parsed.PCV_17001A },
      PCV_17002A: { ...DEFAULT_VALVES.PCV_17002A, ...parsed.PCV_17002A },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("LPCompSuctDrumA_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [FIC_15004, setFIC_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_15004")) || 0;
            setFIC_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_15004, setPT_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_15004")) || 0;
            setPT_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_15004, setTT_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_15004")) || 0;
            setTT_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV17001AOpen = valves?.XV_17001A === false;
  const isXV17002AOpen = valves?.XV_17002A === false;
  const isXV17003AOpen = valves?.XV_17003A === false;
  const isXV17004AOpen = valves?.XV_17004A === false;
  const isXV17005AOpen = valves?.XV_17005A === false;
  const isXV17006AOpen = valves?.XV_17006A === false;

    const isP17001AOn = pumpData?.["P-17001A"]?.running ?? false;




 const FIC_17001A = isXV17001AOpen ? FIC_15004 : 0;
 const PT_17001A = isXV17001AOpen ? PT_15004 : 0.03;
 const TT_17001A = isXV17001AOpen ? TT_15004 : 22;


const FIC_17004A = isXV17006AOpen ? 30.54 : 0;
const PT_17006A = isXV17006AOpen ? 1.3 : 0.03;
const TT_17004A = isXV17006AOpen ? 24 : 28;


const coolerResults = simulateCooler({

  coolerId: "LP_COOLER_A",

  gasFlow: FIC_17001A,
  gasTempIn: TT_17001A,
  gasPressureIn: PT_17001A,

  waterFlow: FIC_17004A,
  waterTempIn: TT_17004A,
  waterPressureIn: PT_17006A,

  gasValveOpen: isXV17001AOpen,
  waterValveOpen: isXV17006AOpen,

  designEfficiency: 0.84,

  foulingFactor: 0.02
});


const TT_17003A = isXV17001AOpen && !isXV17006AOpen? TT_17001A : (isXV17001AOpen) ? 
  coolerResults.gasTempOut*0.45 : 24;

const PT_17002A = isXV17001AOpen && !isXV17006AOpen? PT_17001A : (isXV17001AOpen) ? 
  coolerResults.gasPressureOut*0.212 : 0.03;

const TT_17002A = isXV17001AOpen && !isXV17006AOpen? TT_17004A : (isXV17001AOpen) ? 
  coolerResults.waterTempOut*1.24 : TT_17004A;


const TT_17005A = TT_17003A * 0.95;

const FIC_17006A = FIC_17001A * 0.78;

const PT_17003A =  isXV17005AOpen ? PT_17002A * ((valveData?.PCV_17001A?.opening || 0)/100) : 0.03;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PT_17003A,
    suctionTemperature: TT_17005A,
    suctionFlow: FIC_17006A,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 2.8
  });


useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PT_17003A,
      suctionTemperature: TT_17005A,
      suctionFlow: FIC_17006A
    });

    forceRender(v => v + 1);

  }, 200); // DCS-like scan time

  return () => clearInterval(interval);

}, [PT_17003A, TT_17005A, FIC_17006A]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_17003A =
  compressorResults.dischargeFlow*1.22;

const PT_17008A =
  compressorResults.dischargePressure*8.9;

const TT_17008A =
  compressorResults.dischargeTemperature;

const PT_17004A = isXV17004AOpen ? 0.3 : 0.03;
const FIC_17008A = isXV17004AOpen ? 1.432 : 0;
const FIC_17007A = compressor.running ? 1.3 + 1.432 : FIC_17008A;

const FIC_17002A = FIC_17003A * 0.3 * (valveData?.PCV_17002A?.opening || 0)/100;

  
  // ================= LP CONDENSATE PUMP (A) =================

const runningPumps17001A = [isP17001AOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow17001A = 0;
const suctionPressure17004A = PT_17004A;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_170051A =  1.3 * (valveData?.FCV_17001A?.opening || 0)/100;
const MIN_DISCH_PRESSURE_170051A = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_170051A = MAX_DISCH_PRESSURE_170051A;
let targetFIC_17005A = 0;

if (runningPumps17001A > 0) {

  // 🔹 Flow boost
  targetFIC_17005A = isXV17004AOpen ? 50 * (valveData?.FCV_17001A?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_170051A = isXV17004AOpen ? MIN_DISCH_PRESSURE_170051A* (valveData?.FCV_17001A?.opening || 0)/100 : 0.03;

}

// ================= STATES =================
const [PT_170051A, setPT_170051A] = useState(() => {
  return Number(localStorage.getItem("PT_170051A")) || 0.03;
});

const [FIC_17005A, setFIC_17005A] = useState(() => {
  return Number(localStorage.getItem("FIC_17005A")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_170051A(prev => {
      const next = prev + (targetPT_170051A - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_17005A(prev => {
      const next = prev + (targetFIC_17005A - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_170051A, targetFIC_17005A]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_170051A", PT_170051A);
}, [PT_170051A]);

useEffect(() => {
  localStorage.setItem("FIC_17005A", FIC_17005A);
}, [FIC_17005A]);




useEffect(() => {
  localStorage.setItem("FIC_17003A", FIC_17003A);
}, [FIC_17003A]);

useEffect(() => {
  localStorage.setItem("PT_17008A", PT_17008A);
}, [PT_17008A]);

useEffect(() => {
  localStorage.setItem("TT_17008B", TT_17008A);
}, [TT_17008A]);





  return (
    <div className="LPCompSuctDrumA-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 200px"
      }}>
        LP COMPRESSOR SUCTION DRUM (A)
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-17001A"
        tag="XV_17001A"
        x={115}
        y={122}
        isClosed={valves.XV_17001A}
        toggle={toggleValve}
      />

      {/* XV-17002A */}
      <Valve
        className="XV-17002A"
        tag="XV_17002A"
        x={878}
        y={186}
        isClosed={valves.XV_17002A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17003A */}
      <Valve
        className="XV-17003A"
        tag="XV_17003A"
        x={1025}
        y={186}
        isClosed={valves.XV_17003A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17004A */}
      <Valve
        className="XV-17004A"
        tag="XV_17004A"
        x={571}
        y={620}
        isClosed={valves.XV_17004A}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17005A */}
      <Valve
        className="XV-17005A"
        tag="XV_17005A"
        x={882}
        y={596}
        isClosed={valves.XV_17005A}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-17006A */}
      <Valve
        className="XV-17006A"
        tag="XV_17006A"
        x={286}
        y={502}
        isClosed={valves.XV_17006A}
        toggle={toggleValve}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-17001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-17001A"
          style={{ position: "absolute", left: 92, top: 722}}  onClick={() => openPanel("FCV_17001A")}>
          
          <defs>
            <linearGradient id="metal_17001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-17001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-17001A"
          style={{ position: "absolute", left: 855, top: 520, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_17001A")}>
          
          <defs>
            <linearGradient id="metal_17001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-17002A */}
        <svg width="30" height="30" viewBox="0 0 200 220" className="PCV-17002A"
          style={{ position: "absolute", left: 707, top: 64}}  onClick={() => openPanel("PCV_17002A")}>
          
          <defs>
            <linearGradient id="metal_17002A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17002A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17002A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 900,
                top: 350,
                width: 150,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PT_17003A,
                TT_17005A,
                FIC_17006A,
                FIC_17003A,
                PT_17008A,
                TT_17008A,
                isXV17001AOpen,
                isXV17006AOpen
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_17001A?.opening || 0)}
        x={117}
        y={762}
      />
      <ValveOutput
        value={Number(valveData?.PCV_17001A?.opening || 0)}
        x={915}
        y={535}
      />
      <ValveOutput
        value={Number(valveData?.PCV_17002A?.opening || 0)}
        x={707}
        y={90}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
        tag="FIC-17001A"
        value={[FIC_17001A]}
        x={226}
        y={117}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />

      <Transmitter
        tag="PT-17001A"
        value={[PT_17001A]}
        x={226}
        y={167}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-17001A"
        value={[TT_17001A]}
        x={326}
        y={117}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-17004A"
        value={[TT_17004A]}
        x={426}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-17006A"
        value={[PT_17006A]}
        x={426}
        y={373}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-17004A"
        value={[FIC_17004A]}
        x={146}
        y={493}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (A) FOR HEAT EXCHANGING WITH GAS"
      />


      <Transmitter
        tag="TT-17003A"
        value={[TT_17003A]}
        x={258}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COOLED GAS AT THE DISCHARGE OF THE LP GAS COOLER (A) TO LP COMPRESSOR SUCTION DRUM (A)"
      />

      <Transmitter
        tag="PT-17002A"
        value={[PT_17002A]}
        x={676}
        y={269}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COOLED GAS AT THE DISCHARGE OF THE LP GAS COOLER (A) TO LP COMPRESSOR SUCTION DRUM (A)"
      />

      <Transmitter
        tag="TT-17002A"
        value={[TT_17002A]}
        x={543}
        y={116}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER AT THE DISCHARGE OF THE LP GAS COOLER (A) TO FRESH WATER RETURN LINE"
      />
      <Transmitter
        tag="TT-17005A"
        value={[TT_17005A]}
        x={920}
        y={666}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE SUCTION OF LP COMPRESSOR (A)"
      />

      <Transmitter
        tag="FIC-17006A"
        value={[FIC_17006A]}
        x={826}
        y={666}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF LP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-17003A"
        value={[PT_17003A]}
        x={776}
        y={492}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF LP COMPRESSOR (A)"
      />
      
      <Transmitter
        tag="FIC-17003A"
        value={[FIC_17003A]}
        x={936}
        y={132}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-17008A"
        value={[PT_17008A]}
        x={1036}
        y={132}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (A)"
      />

      <Transmitter
        tag="TT-17008A"
        value={[TT_17008A]}
        x={1124}
        y={132}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (A)"
      />

      <Transmitter
        tag="PT-17004A"
        value={[PT_17004A]}
        x={466}
        y={706}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (A) GOING TO LP CONDENSATE PUMP"
      />


      <Transmitter
        tag="FIC-17008A"
        value={[FIC_17008A]}
        x={656}
        y={720}
        unit="LPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (A) GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-17005A"
        value={[FIC_17005A]}
        x={226}
        y={667}
        unit="LPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF LP CONDENSATE PUMP (A) GOING BACK TO 3RD STAGE SEPARATOR"
      />

      <Transmitter
        tag="PT-170051A"
        value={[PT_170051A]}
        x={226}
        y={680}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF LP CONDENSATE PUMP (A) GOING BACK TO 3RD STAGE SEPARATOR"
      />


      <Transmitter
        tag="FIC-17002A"
        value={[FIC_17002A]}
        x={426}
        y={117}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS RETURNED FROM THE DISCHARGE OF THE LP COMPRESSOR FOR ANTI-SURGE PROTECTION"
      />

      <Transmitter
        tag="FIC-17007A"
        value={[FIC_17007A]}
        x={1106}
        y={720}
        unit="LPM"
        max={10}
        HH={9}
        H={8}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (A) AND COMPRESSOR DURING PURGING AND BLOWDOWN GOING TO DE-OILER VESSEL"
      />










      <Pump
        tag="P-17001A"
        x={375}
        y={749}
        rpm={1800}
        bladeCount={pumpData?.["P-17001A"]?.bladeCount || 5}
        size={pumpData?.["P-17001A"]?.size || 35}
        onClick={openPumpPanel}
      />

      <LevelTransmitterIndicator
      tag="LT_17001A"
      totalLevel={100000}
      inflows={[FIC_17001A * 0.08]}
      outflows={[FIC_17005A]}
      responseFactor={0.05}
      columnX={626}
      columnY={410}
      columnWidth={52}
      columnHeight={147}
      textX={529}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />





      
           
          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}


    </div>
  );
}


export default LPCompSuctDrumA;